import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';

import css from './IconHudl.module.css';

const IconHudl = props => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || css.root, className);
  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      width="60"
      height="60"
      viewBox="0 0 60 60"
    >
      <g className="layer">
        <path
          id="mark"
          d="M30.37 59.5c-4.63 0-8.63-3.13-9.73-7.62 0-.06-.06-.12-.12-.12-1.31-.53-2.58-1.15-3.8-1.89l-.09-.09a26.17 26.17 0 0 1-1.31-14.36c0-.06.06-.12.12-.15h.03c.06 0 .12 0 .15.06 2.43 2.63 5.4 4.73 8.69 6.17.03 0 .06.03.09 0 .03 0 .09 0 .12-.03 4.33-3.1 10.38-2.25 13.68 1.95.03.06.09.06.15.06h.03c.92-.12 1.84-.3 2.76-.5 5.43-1.33 10.32-4.31 13.94-8.54a.23.23 0 0 1 .15-.06c.03 0 .06 0 .09.03.09.03.12.12.09.21-2.2 7.71-7.8 14-15.25 17.08-.06.03-.09.06-.12.12a9.89 9.89 0 0 1-9.67 7.68M11.71 45.88c-.06 0-.09-.03-.12-.06a25.77 25.77 0 0 1-7.21-21.65c0-.06 0-.12-.06-.15a9.9 9.9 0 0 1-1.84-12.17c2.28-3.99 7.03-5.91 11.48-4.61.06.03.12 0 .18-.03 1.13-.89 2.31-1.68 3.56-2.36.03-.03.06-.03.09-.03 4.89.74 9.46 2.87 13.2 6.06.06.06.09.12.06.18s-.06.12-.15.15c-3.53.8-6.82 2.3-9.73 4.4q-.09.045-.09.18c.03.32.06.68.06 1-.03 4.93-3.68 9.1-8.6 9.81-.06 0-.12.06-.15.12-.36.86-.65 1.74-.92 2.63a26.4 26.4 0 0 0 .44 16.28c.03.06 0 .12-.03.18q-.09.09-.18.09zm32.72-9.28a.23.23 0 0 1-.15-.06c-.03-.06-.06-.12-.03-.18 1.04-3.37 1.39-6.94 1.04-10.46 0-.06-.06-.12-.12-.15a9.95 9.95 0 0 1-5.78-8.98c0-1.3.24-2.6.74-3.78.03-.06.03-.12-.03-.18-.59-.77-1.25-1.54-1.9-2.25-3.86-4.05-8.9-6.77-14.39-7.77-.09-.03-.15-.09-.15-.18s.06-.18.15-.18c7.86-2.01 16.23-.27 22.6 4.76.03.03.06.03.12.03h.06a9.7 9.7 0 0 1 2.79-.41c4.09 0 7.77 2.48 9.29 6.26 1.51 3.78.53 8.12-2.43 10.9a.23.23 0 0 0-.06.15c.15 1.15.24 2.3.24 3.49v.53c0 .03-.03.09-.03.12a26.43 26.43 0 0 1-11.84 8.33h-.12z"
          className="st0"
        ></path>
      </g>
    </svg>
  );
};

IconHudl.defaultProps = {
  rootClassName: null,
  className: null,
  fillColor: null,
};

IconHudl.propTypes = {
  rootClassName: string,
  className: string,
  fillColor: string,
};

export default IconHudl;
